import { useEffect } from "react";
import { useProducts } from "../../utils/hooks/useProducts";
import ProductCard from "../productCard";
import { toast } from "sonner";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
// import "swiper/swiper-bundle.min.css";

const FeatureProductList = () => {
  const { data: products = [], isLoading, error } = useProducts();

  useEffect(() => {
    if (error) {
      toast.error(`Error fetching products: ${error.message}`);
    } else if (!isLoading && products.length > 0) {
      toast.success("Products loaded successfully!");
    }
  }, [isLoading, error, products]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <section className="p-6 bg-gray-100 ">
      <div className="mx-10">
        <h1 className="text-5xl font-bold">Featured Listings</h1>
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={1} // Default for small screens
          slidesPerGroup={1}
          loop
          pagination={{
            clickable: true, // Pagination dots enabled
          }}
          autoplay={{ delay: 3000 }}
          // spaceBetween={16}
          // slidesPerView={1}
          breakpoints={{
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
          }}
          navigation
          // pagination={{ clickable: true }}
          // loop
          className="my-10"
        >
          {products.map((product: any) => (
            <SwiperSlide key={product.id} className="py-16">
              <ProductCard singleProduct={product} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default FeatureProductList;
